import { PolicyDetails, ConsentPolicy } from '..';
import { DEFAULT_POLICY } from '../default-policies';
import { getPolicyFromCookie, mappingFromCookie, clone } from './cookie-parser-common'
import { COOKIE_NAME } from './consts';

function getCurrentPolicy(
  consentPolicy?: ConsentPolicy,
): PolicyDetails {
  const cookiePolicy = getPolicyFromCookie();
  if (cookiePolicy) {
    return cookiePolicy;
  }
  const policy = consentPolicy
    ? clone(consentPolicy)
    : clone(DEFAULT_POLICY);
  return {
    defaultPolicy: true,
    policy,
  };
}

function removeCookie(baseUrl: string): boolean {
  const policy = getPolicyFromCookie();
  if (policy && !policy.defaultPolicy) {
    document.cookie = `${COOKIE_NAME}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; domain=${baseUrl}; path=/;`;
    return true;
  }
  return false;
}

function getConsentPolicyHeader(consentPolicy?: ConsentPolicy) {
  const policy = getCurrentPolicy(consentPolicy).policy;
  let somethingIsDenied = false;
  const raw = Object.keys(mappingFromCookie).reduce(
    (ret: { [name: string]: number }, key) => {
      const value = mappingFromCookie[key];
      // @ts-expect-error
      const policyValue = policy[value];
      ret[key] = policyValue ? 1 : 0;
      if (!policyValue) {
        somethingIsDenied = true;
      }
      return ret;
    },
    {},
  );
  return somethingIsDenied
    ? { [COOKIE_NAME]: encodeURIComponent(JSON.stringify(raw)) }
    : {};
}

export { getCurrentPolicy, removeCookie, getConsentPolicyHeader };
